import { useState } from "react";

const styles = `
.cf-body{min-height:100vh;display:flex;align-items:center;justify-content:center;background:#f6f4ee;font-family:Georgia,'Times New Roman',serif;color:#1c2b25;padding:24px;}
.cf-card{width:100%;max-width:460px;background:#ffffff;border:1px solid #d9d4c7;border-radius:10px;padding:40px 36px;box-shadow:0 2px 10px rgba(0,0,0,0.04);}
.cf-title{font-size:1.5rem;margin:0 0 6px;letter-spacing:0.3px;}
.cf-sub{font-family:Arial,Helvetica,sans-serif;font-size:0.85rem;color:#6b7268;margin:0 0 28px;}
.cf-label{display:block;font-family:Arial,Helvetica,sans-serif;font-size:0.78rem;text-transform:uppercase;letter-spacing:0.06em;color:#4b564e;margin-bottom:6px;}
.cf-field{margin-bottom:20px;}
.cf-input{width:100%;padding:11px 12px;font-family:Arial,Helvetica,sans-serif;font-size:0.95rem;border:1px solid #d9d4c7;border-radius:6px;background:#fdfcf9;color:#1c2b25;outline:none;transition:border-color .15s ease, background .15s ease;}
.cf-input:focus{border-color:#3a6351;background:#fff;}
.cf-button{width:100%;margin-top:8px;padding:12px;font-family:Arial,Helvetica,sans-serif;font-size:0.95rem;font-weight:bold;letter-spacing:0.03em;color:#fff;background:#3a6351;border:none;border-radius:6px;cursor:pointer;transition:background .15s ease;}
.cf-button:hover{background:#2c4d40;}
.cf-button:disabled{opacity:0.6;cursor:not-allowed;}
.cf-status{margin-top:14px;font-family:Arial,Helvetica,sans-serif;font-size:0.85rem;text-align:center;}
.cf-status--ok{color:#3a6351;}
.cf-status--err{color:#b03a2e;}
`;

const API_BASE_URL = "";

export default function ContactForm() {
  const [identifier, setIdentifier] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setResult(null);

    try {
      const res = await fetch(`${API_BASE_URL}/api/checkin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ identifier }),
      });

      const data = await res.json();

      if (!res.ok) {
        setResult({
          ok: false,
          message: data.error || "No matching registration found. Please check your details.",
        });
        return;
      }

      setResult({
        ok: true,
        message: `Welcome, ${data.attendee.fullName}! You're checked in.`,
      });

      setIdentifier("");
    } catch (err) {
      console.error(err);
      setResult({ ok: false, message: "Something went wrong. Please try again." });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="cf-body">
      <style>{styles}</style>
      <div className="cf-card">
        <h1 className="cf-title">Event Check-In</h1>
        <p className="cf-sub">Enter your mobile number or email to check in.</p>
        <form onSubmit={handleSubmit}>
          <div className="cf-field">
            <label className="cf-label" htmlFor="identifier">Mobile Number or Email</label>
            <input
              className="cf-input"
              type="text"
              id="identifier"
              name="identifier"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              required
            />
          </div>
          <button className="cf-button" type="submit" disabled={submitting}>
            {submitting ? "Checking in..." : "Submit"}
          </button>
          {result && (
            <p className={`cf-status ${result.ok ? "cf-status--ok" : "cf-status--err"}`}>
              {result.message}
            </p>
          )}
        </form>
      </div>
    </div>
  );
}